import { EventsPage } from '@/components/admin/events/EventsPage/EventsPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(EventsPage, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
